import { EmptyState } from '@/components/EmptyState/EmptyState';
import { useAmelioTranslations } from '@/hooks';

interface CompensationLoadFailedStateProps {
    onRetry: () => void;
}

/**
 * What the report shows when a request it needs came back in error. Never the "nothing here yet"
 * state: a network cut that reads "aucun cycle" or "aucune enveloppe" sends an HR partner off to
 * create what already exists, or to conclude a budget was lost.
 */
export const CompensationLoadFailedState = ({ onRetry }: CompensationLoadFailedStateProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            role={'alert'}
            data-testid={'compensation-load-failed'}
        >
            <EmptyState
                title={t('compensation.errors.loadFailed.title')}
                message={t('compensation.errors.loadFailed.message')}
                action={{ label: t('compensation.errors.loadFailed.retry'), onClick: onRetry }}
            />
        </div>
    );
};
